<template>
    <!-- <div class="backdrop" @click.self="closeModal"> -->
    <div class="backdrop">
        <div class="modal">
            <h1>{{ modalHeader }}</h1>
            <form action="" class="form">
                <div class="form__group">
                <input type="text" v-model="title" :disabled="isLocked" placeholder="" class="form__input" id="referential_title" :maxlength="getMaxLength('title')"/>
                <label for="referential_title" class="form__label">Nom </label>
                <span class="form__p">({{ title.length }}/{{ getMaxLength('title') }})</span>
                </div>

                <div class="form__group">
                <input type="text" v-model="description" :disabled="isLocked" placeholder="" class="form__input" id="referential_description" :maxlength="getMaxLength('description')"/>
                <label for="referential_description" class="form__label">Description</label>
                <span class="form__p">({{ description.length }}/{{ getMaxLength('description') }})</span>
                </div>
            
                <div class="form__group">
                <input type="text" v-model="geolocation" :disabled="isLocked" placeholder="" class="form__input" id="referential_geolocation" :maxlength="getMaxLength('site')"/>
                <label for="referential_geolocation" class="form__label">Site géographique </label>
                <span class="form__p">({{ geolocation.length }}/{{ getMaxLength('site') }})</span>
                </div>
                <br>
                <div class="form_group">
                    <input type="checkbox" :checked="show_graphs" @change="show_graphs = $event.target.checked" :disabled="isLocked" id="referential_graphs" class="form__input">
                    <span for="referential_graphs" class="form__label">Afficher les graphiques d'évaluations à 2000W</span>
                </div>

                <!-- <select v-if="selectedReferential" v-model="releaseStatus" class="form__select" id="releaseStatus">
                    <option value="EDITING">Mode édition</option>
                    <option value="VALIDATION">Mode test</option>
                    <option value="RELEASE">Mode production</option>
                    <option value="ARCHIVE">Archivé</option>
                </select> -->
                <!-- <div v-if="selectedReferential && !isReferentialLocked(selectedReferential)" class="action-buttons">
                    <button v-if="releaseStatus === 'RELEASE'" @click.prevent="changeReferentialStatus('ARCHIVE')" class="create-button">Archiver</button>
                    <button v-if="releaseStatus === 'RELEASE' && (getProjectsAfterValidation+getProjectsInValidation === 0)" @click.prevent="changeReferentialStatus('EDITING')" class="create-button">Remise en édition</button>
                    <button v-if="releaseStatus === 'EDITING' && selectedReferential > 0" @click.prevent="changeReferentialStatus('RELEASE')" class="create-button">Mise en production</button>
                    <button v-if="releaseStatus === 'ARCHIVE' && selectedReferential > 0" @click.prevent="changeReferentialStatus('EDITING')" class="create-button">Retour en édition</button>
                </div> -->
                <label v-if="selectedReferential" for="releaseStatus" class="form__label"></label>
                <button v-if="!isReferentialLocked(selectedReferential)" @click.prevent="submitForm">{{ submitButton }}</button>
                <button @click.prevent="closeModal">Annuler</button>
            </form>
        </div>
    </div>
    <ConfirmationDialog v-if="canEditList.confirmationDialogOpen" />
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import '../../assets/styles/base.css'
import '../../assets/styles/modal.css'
import ConfirmationDialog from '../generic/ConfirmationDialog.vue';

export default {
    name: "ReferentialModalCreator",
    components: {
        ConfirmationDialog,
    },
    data() {
        return {
            title: "",
            description: "",
            geolocation: "",
            show_graphs:true,
            releaseStatus: "EDITING",
            modalHeader: "Création d'un nouveau Référentiel",
            submitButton: "Créer"
        }
    },  
    computed: {
        ...mapState("referential", ["criteriaTree", "referentialData", "selectedReferential", 'canEditList',"maxLength", "referentialErrors"]),
        ...mapGetters("referential", ["filterActiveReferential", "isReferentialLocked", "getMaxLength", "getProjectsInValidation"]),
        isLocked() {
            if(!this.selectedReferential || this.selectedReferential === 0) {
                return false;
            }
            return this.isReferentialLocked(this.selectedReferential)
        },
    },
    mounted() {
        //console.log("Modal Creator Open")
        //OBJECT{} (wrong way but working !)
        if(this.selectedReferential > 0) {
            var referential = this.filterActiveReferential
            //console.log("referential loaded : ", referential)
            this.title = referential[0].title
            this.description = referential[0].description
            this.geolocation = referential[0].site
            this.show_graphs = referential[0].show_graphs
            this.modalHeader = "Éditer un référentiel"
            this.submitButton = "OK"
            this.releaseStatus = referential[0].status
        }
        document.body.classList.add('modal-open');
    },
    beforeUnmount() {
    document.body.classList.remove('modal-open');
    },
    methods: {
        closeModal() {
            //console.log("IS IT CLOSING WITHOUT MY APPROVAL ? ");
            this.$store.commit("referential/toggleReferenentialModalNew", false)
            this.$emit('close')
        },
        async submitForm() {
            //console.log("Just clicking on submit, kinda")
            if(this.selectedReferential > 0) {
                this.$store.dispatch("referential/referentialUpdate", {
                    title: this.title,
                    description: this.description,
                    site: this.geolocation,
                    status: this.newStatus,
                    show_graphs: this.show_graphs,
                })
            } else {
                const id = await this.$store.dispatch("referential/referentialInsert", {
                    title: this.title,
                    description: this.description,
                    site: this.geolocation,
                    status: this.newStatus,
                    show_graphs: this.show_graphs,
                    /* VERIFY IF NEWSTATUS IS CORRECT(before releaseStatus) */
                })
                //Not sure if it was needed ?
                this.$router.push(`/referential/${id.referentiel_id}`)
            }
            this.title = ""
            this.description = ""
            this.closeModal()
        },
        /* async changeReferentialStatus(status) {
            await this.$store.dispatch("referential/referentialValidate", {
                id: this.selectedReferential
            })
            let title = ""
            let message = ""
            //const hasBlockingError = this.referentialErrors.some(error => error.status === 'ERREUR');
            const hasErrors = this.referentialErrors && this.referentialErrors.length > 0;

            if (hasErrors) {
                    title = "Le référentiel a des problèmes :";
                    for (const error of this.referentialErrors) {
                            message += `<b>Status:</b> ${error.status}<br>`;
                            message += `<b class="parameters">Paramètre:</b> ${error.parameter}<br>`;
                            message += `<b>Message:</b> ${error.message}<br><br>`;
                        }
                        this.$store.commit("referential/returnConfirmationObjectMutation", { 
                            id: this.selectedReferential, 
                            type: "referential-change-status",
                            title: title,
                            message: message,
                            newStatus: status,
                            //hasBlockingError: hasBlockingError,
                            status: this.releaseStatus,
                        })
                        return;
                    } else {
                    switch (status) {
                    case "RELEASE":
                        title = "Mise en production";
                        message = "Êtes-vous sûr de vouloir mettre ce référentiel en production ?";
                    break;
                    case "ARCHIVE":
                        title = "Archiver"
                        message = "Êtes-vous sûr de vouloir archiver ce référentiel ?"
                        break;
                    default:
                        title = "Remise en édition"
                        message = "Êtes-vous sûr de vouloir remettre ce référentiel en édition ?"
                        break;
                }
                this.$store.commit("referential/returnConfirmationObjectMutation", { 
                    id: this.selectedReferential, 
                    type: "referential-change-status",
                    title: title,
                    message: message,
                    //hasBlockingError: hasBlockingError,
                    newStatus: status,
                })
                this.closeModal();
            }
            //console.log("Changing referential status to : ", status)
            }    */ 
        },
        
    };
</script>

<style scoped>

</style>